import React from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Row, Card, Form, Input, Radio, Select, Space, Button, Popover, Col, Typography } from 'antd'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero } from './components'

import AddVehicleStyle from '../../styles/AddVehicle.module.css'

import {
  VEHICLE_OWNERSHIP,
  VEHICLE_COLLISION_PA,
  VEHICLE_COLLISION_DEDUCTIBLE_PA,
  VEHICLE_DAYS_USAGE,
  VEHICLE_DAYS_DRIVE_MILES,
  OTHER_THAN_COLLISION_COVERAGE_MI,
  RENTAL_REIMBURSEMENT_MI,
  COLLISION_COVERAGE_DAMAGE_MI
} from './AddVehicleConstants'

const { Text } = Typography
const { Option } = Select
const { TextArea } = Input

const AddVehicle = ({ paVehicle, setPAVehicle, handleSubmit, validate }) => {
  const updateUserTextFields = (text, field) => {
    const clonedVehicle = { ...paVehicle }
    clonedVehicle[field] = text
    setPAVehicle(clonedVehicle)
  }
  
  return (
    <>
      <EmptyHeaderHero minHeight={true} title="Add Vehicle - Pennsylvania" />
      <div className={`${AddVehicleStyle["add-vehicle"]}`}>
        <p className={`${AddVehicleStyle["disclaimer"]}`}>Once your change request has been approved and processed, you will be sent updated policy documents and billing schedule.</p>
        <Row>
          <Card className={`${AddVehicleStyle["register-card"]}`}>
            <h5 className={`${AddVehicleStyle["sub-label"]}`}>Policyholder Information</h5>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "firstName") }}
                    placeholder="First Name*"
                    value={paVehicle.firstName}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "lastName") }}
                    placeholder="Last Name*"
                    value={paVehicle.lastName}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "policyNumber") }}
                    placeholder="Policy Number*"
                    value={paVehicle.policyNumber}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["input-text"]} ${AddVehicleStyle["phone-number"]}`}
                    mask="(999) 999-9999"
                    onChange={event => { updateUserTextFields(event.target.value, "phoneNumber") }}
                    placeholder="Phone Number*"
                    value={paVehicle.phoneNumber}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      setPAVehicle({
                        ...paVehicle,
                        streetAddress: event.target.value
                      })
                    }}
                    placeholder="Street Address*"
                    value={paVehicle.streetAddress}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    maxLength={5}
                    onChange={event => {
                      setPAVehicle({
                        ...paVehicle,
                        zipCode: event.target.value.replace(/\D/g, '')
                      })
                    }}
                    placeholder="Zip Code*"
                    value={paVehicle.zipCode}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "emailAddress") }}
                    placeholder="Email Address*"
                    value={paVehicle.emailAddress}
                  />
                </Form.Item>
              </Col>
            </Row>
            <h5 className={`${AddVehicleStyle["sub-label"]}`}>Vehicle Information</h5>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.vin = event.target.value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="VIN*"
                    value={paVehicle.vehicleInfo.vin}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Row>
                  <Col xl={{ span: 7 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.year = event.target.value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Year*"
                        value={paVehicle.vehicleInfo.year}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 7, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.make = event.target.value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Make*"
                        value={paVehicle.vehicleInfo.make}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.model = event.target.value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Model*"
                        value={paVehicle.vehicleInfo.model}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.stateRegistered = event.target.value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="State Vehicle will be Registered*"
                    value={paVehicle.vehicleInfo.stateRegistered}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["dob"]}`}
                    mask="99/99/9999"
                    onChange={event => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.purchaseDate = event.target.value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Date Vehicle Purchased (mm/dd/yyyy)*"
                    value={paVehicle.vehicleInfo.purchaseDate}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>In whose name will the vehicle be registered?*</Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.registeredPersonFirstName = event.target.value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="First Name*"
                    value={paVehicle.vehicleInfo.registeredPersonFirstName}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.registeredPersonLastName = event.target.value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Last Name*"
                    value={paVehicle.vehicleInfo.registeredPersonLastName}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>
              Number of days per week this vehicle is used to drive to work, school or public transportation site?*
            </Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={value => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.noOfDaysUsed = value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={paVehicle.vehicleInfo.noOfDaysUsed}
                  >
                    {VEHICLE_DAYS_USAGE.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>How many miles one-way?*</Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={value => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.oneWayMiles = value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={paVehicle.vehicleInfo.oneWayMiles}
                  >
                    {VEHICLE_DAYS_DRIVE_MILES.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is this vehicle owned, leased, or financed?*</Text>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={value => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.vehicleOwnership = value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={paVehicle.vehicleInfo.vehicleOwnership}
                  >
                    {VEHICLE_OWNERSHIP.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {(paVehicle.vehicleInfo.vehicleOwnership === 'Leased' ||
              paVehicle.vehicleInfo.vehicleOwnership === 'Financed') && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddVehicleStyle["input-text"]}`}
                      onChange={event => {
                        const vehicleInfo = { ...paVehicle.vehicleInfo }
                        vehicleInfo.nameOfBank = event.target.value
                        setPAVehicle({
                          ...paVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="Name of Bank/Leasing Company*"
                      value={paVehicle.vehicleInfo.nameOfBank}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is there a Co-Owner/Co-Buyer/Co-Lessee?*</Text>
                <Radio.Group
                  className={`${AddVehicleStyle["row-margin-bottom-8"]}`}
                  onChange={event => {
                    const vehicleInfo = { ...paVehicle.vehicleInfo }
                    vehicleInfo.isVehicleWithCoOwnership = event.target.value
                    setPAVehicle({
                      ...paVehicle,
                      vehicleInfo
                    })
                  }}
                  value={paVehicle.vehicleInfo.isVehicleWithCoOwnership}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {paVehicle.vehicleInfo.isVehicleWithCoOwnership === 'Yes' && (
              <Row className={`${AddVehicleStyle["row-margin-top-8"]}`}>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddVehicleStyle["input-text"]}`}
                      onChange={event => {
                        const vehicleInfo = { ...paVehicle.vehicleInfo }
                        vehicleInfo.coOwnershipPersonFirstName = event.target.value
                        setPAVehicle({
                          ...paVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="First Name*"
                      value={paVehicle.vehicleInfo.coOwnershipPersonFirstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddVehicleStyle["input-text"]}`}
                      onChange={event => {
                        const vehicleInfo = { ...paVehicle.vehicleInfo }
                        vehicleInfo.coOwnershipPersonLastName = event.target.value
                        setPAVehicle({
                          ...paVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="Last Name*"
                      value={paVehicle.vehicleInfo.coOwnershipPersonLastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row>
              <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Do you choose “Other than Collision” (Comprehensive) coverage?*</Text>
              <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{OTHER_THAN_COLLISION_COVERAGE_MI}</p>} title={null}>
                <InfoCircleOutlined />
              </Popover>
            </Row>
            <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  onChange={event => {
                    const vehicleInfo = { ...paVehicle.vehicleInfo }
                    vehicleInfo.otherCollisionCoverage = event.target.value
                    setPAVehicle({
                      ...paVehicle,
                      vehicleInfo
                    })
                  }}
                  value={paVehicle.vehicleInfo.otherCollisionCoverage}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {paVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>
                  Choose your “Other than Collision” (Comprehensive) deductible. (The standard deductible in
                  Pennsylvania is $500)*
                </Text>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Select
                        onChange={value => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.otherCollisionDeductible = value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Select from the following"
                        value={paVehicle.vehicleInfo.otherCollisionDeductible}
                      >
                        {VEHICLE_COLLISION_PA.map((item, index) => (
                          <Option key={index} value={item.label}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {paVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Row>
                    <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Do you choose “Collision” coverage?*</Text>
                    <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{COLLISION_COVERAGE_DAMAGE_MI}</p>} title={null}>
                      <InfoCircleOutlined />
                    </Popover>
                  </Row>
                  <Radio.Group
                    className={`${AddVehicleStyle["row-margin-bottom-8"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...paVehicle.vehicleInfo }
                      vehicleInfo.collisionCoverage = event.target.value
                      setPAVehicle({
                        ...paVehicle,
                        vehicleInfo
                      })
                    }}
                    value={paVehicle.vehicleInfo.collisionCoverage}
                  >
                    <Radio value="Yes">Yes</Radio>
                    <Radio value="No">No</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            )}
            {paVehicle.vehicleInfo.collisionCoverage === 'Yes' && (
              <>
                {' '}
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>
                  Choose your “Collision” coverage deductible. (The standard deductible in Pennsylvania is $500)*
                </Text>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Select
                        onChange={value => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.collisionCoverageDeductible = value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Select from the following"
                        value={paVehicle.vehicleInfo.collisionCoverageDeductible}
                      >
                        {VEHICLE_COLLISION_DEDUCTIBLE_PA.map((item, index) => (
                          <Option key={index} value={item.label}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {paVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <>
                <Row>
                  <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Do you choose Rental Reimbursement coverage?*</Text>
                  <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{RENTAL_REIMBURSEMENT_MI}</p>} title={null}>
                    <InfoCircleOutlined />
                  </Popover>
                </Row>
                <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
                  <Col xl={{ span: 6 }} xs={{ span: 24 }}>
                    <Radio.Group
                      onChange={event => {
                        const vehicleInfo = { ...paVehicle.vehicleInfo }
                        vehicleInfo.rentalReimbursementCoverage = event.target.value
                        setPAVehicle({
                          ...paVehicle,
                          vehicleInfo
                        })
                      }}
                      value={paVehicle.vehicleInfo.rentalReimbursementCoverage}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
              </>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is this vehicle primarily kept overnight at the policy address?*</Text>
            <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  onChange={event => {
                    const vehicleInfo = { ...paVehicle.vehicleInfo }
                    vehicleInfo.isVehiclePrimarilyKeptOvernight = event.target.value
                    setPAVehicle({
                      ...paVehicle,
                      vehicleInfo
                    })
                  }}
                  value={paVehicle.vehicleInfo.isVehiclePrimarilyKeptOvernight}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {paVehicle.vehicleInfo.isVehiclePrimarilyKeptOvernight === 'No' && (
              <>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Where will the vehicle be kept overnight?*</Text>
                <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.streetAddress = event.target.value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Street Address*"
                        value={paVehicle.vehicleInfo.overnightVehicleAddress.streetAddress}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.apt = event.target.value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Apartment#"
                        value={paVehicle.vehicleInfo.overnightVehicleAddress.apt}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.city = event.target.value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="City*"
                        value={paVehicle.vehicleInfo.overnightVehicleAddress.city}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.state = event.target.value
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="State*"
                        value={paVehicle.vehicleInfo.overnightVehicleAddress.state}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        maxLength={5}
                        onChange={event => {
                          const vehicleInfo = { ...paVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.zipCode = event.target.value.replace(/\D/g, '')
                          setPAVehicle({
                            ...paVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Zip Code*"
                        value={paVehicle.vehicleInfo.overnightVehicleAddress.zipCode}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is your vehicle being used for business purposes?*</Text>
            <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  onChange={event => {
                    setPAVehicle({
                      ...paVehicle,
                      isBusinessPurpose: event.target.value
                    })
                  }}
                  value={paVehicle.isBusinessPurpose}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {paVehicle.isBusinessPurpose === 'Yes' && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <TextArea
                      autoComplete="off"
                      className={`${AddVehicleStyle["textarea-text"]}`}
                      onChange={event => {
                        setPAVehicle({
                          ...paVehicle,
                          reason: event.target.value
                        })
                      }}
                      placeholder="Please explain why*"
                      rows={4}
                      value={paVehicle.reason}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>What date would you like this change to go into effect?*</Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["dob"]}`}
                    mask="99/99/9999"
                    onChange={event => {
                      setPAVehicle({
                        ...paVehicle,
                        effectDate: event.target.value
                      })
                    }}
                    placeholder="mm/dd/yyyy*"
                    value={paVehicle.effectDate}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Row>
        <Row className={`${AddVehicleStyle["submit-container"]}`}>
          <Form.Item className={`${AddVehicleStyle["btn-control"]} ${AddVehicleStyle["button-submit-form"]}`}>
            <Space>
              <Button className={`${AddVehicleStyle["register"]} ${AddVehicleStyle["register-form-button"]}`} disabled={validate} onClick={handleSubmit}>
                Submit
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </div>
    </>
  )
}

AddVehicle.propTypes = {
  handleSubmit: PropTypes.func,
  paVehicle: PropTypes.object,
  setPAVehicle: PropTypes.func,
  validate: PropTypes.func
}

export default AddVehicle
